<template>
  <button
    type="button"
    @click="$modal.closeModal"
  >
    <i class="fas fa-times"></i>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonTheModalCloseIcon'
}
</script>
